// ============================================================================
// BonBoZ: xuất bảng thống kê ra file mở được bằng Excel.
//
// KHÔNG dùng `downloadCsvFile` của upstream (helper/downloadHelper.js) vì nó
// thiếu hai thứ mà tiếng Việt + Excel bắt buộc phải có:
//
//   1. BOM UTF-8 ở đầu file. Không có nó Excel đoán mã hoá theo codepage máy
//      (Windows-1258/1252) và mọi chữ có dấu vỡ thành "PhÃ²ng KhÃ¡m".
//   2. Dòng "sep=," đầu file. Excel cài locale Việt Nam dùng DẤU CHẤM PHẨY làm
//      ký tự tách cột, mở CSV tách bằng phẩy là cả bảng dồn vào một cột. Dòng
//      hint này là quy ước riêng của Excel, ép nó tách bằng phẩy bất kể
//      locale; các phần mềm khác không hiểu thì bỏ qua dòng đầu, không hỏng gì.
//
// Vẫn là CSV chứ không phải .xlsx thật: dự án không có thư viện xlsx nào, mà
// thêm một dependency chỉ để né một dòng hint thì không đáng. Excel mở CSV
// bằng đúp chuột như file của nó.
// ============================================================================
import { format, fromUnixTime } from 'date-fns';

// Viết dạng escape chứ không dán ký tự thật: BOM vô hình, editor/linter nào
// "dọn rác" mất nó là mọi file xuất ra vỡ dấu mà diff không nhìn thấy gì.
const BOM = '\uFEFF';

// Bọc ngoặc kép khi giá trị chứa ký tự có nghĩa với CSV. Ngoặc kép bên trong
// nhân đôi theo chuẩn RFC 4180.
const oCsv = gia => {
  const chu = String(gia ?? '');
  return /[",;\n\r]/.test(chu) ? `"${chu.replace(/"/g, '""')}"` : chu;
};

/**
 * Tải xuống một bảng dưới dạng CSV mở được bằng Excel.
 * @param {string} tenFile - tên file, kèm đuôi .csv.
 * @param {Array<Array>} cacHang - mảng các hàng, mỗi hàng là mảng ô (hàng đầu
 *   thường là tiêu đề cột). Ô nhận chuỗi/số; null/undefined thành ô trống.
 */
export const taiXuongExcel = (tenFile, cacHang) => {
  const noiDung =
    BOM + ['sep=,', ...cacHang.map(h => h.map(oCsv).join(','))].join('\r\n');
  const blob = new Blob([noiDung], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('download', tenFile);
  link.setAttribute('href', url);
  link.click();
  URL.revokeObjectURL(url);
};

/**
 * Tên file thống nhất cho mọi trang Thống kê: `<phần>_<từ>_<đến>.csv`.
 * Ngày viết dd-MM-yyyy (không dùng khuôn hiển thị d/M/yyyy — dấu gạch chéo
 * không được phép trong tên file).
 * @param {string} phan - tên phần, ví dụ 'thong-ke-trang'.
 * @param {number|null} tu - epoch giây đầu kỳ.
 * @param {number|null} den - epoch giây cuối kỳ.
 */
export const tenFileThongKe = (phan, tu, den) => {
  const d = moc => format(fromUnixTime(Number(moc)), 'dd-MM-yyyy');
  const ky = tu && den ? `_${d(tu)}_${d(den)}` : '';
  return `${phan}${ky}.csv`;
};
